import { JwtAxios } from '@/packaging';

export const shopifyApi = {
  async GetShopifyTemplate(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetShopifyTemplate?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  // POST /api/Template/Market/SetShopifyAccount
  // payload: { marketAccount, apiKey, apiVersion?, connectionDomain? }
  async SetShopifyAccount(model) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/SetShopifyAccount`,
      model
    );
    return responseModel;
  },
  async SetShopifyTemplate(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetShopifyTemplate`, model);
    return responseModel;
  },
  // POST /api/Template/Market/ShopifyOAuthCallback
  // payload: { hmac, shop, host, timestamp, code, state }
  async ShopifyOAuthCallback(model) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/ShopifyOAuthCallback`,
      model
    );
    return responseModel;
  },
  // GET /api/Template/Market/ShopifyOAuthCallback
  // query params: hmac, shop, host, timestamp, code, state
  async ShopifyOAuthCallbackGet(params) {
    const queryString = new URLSearchParams(params).toString();
    const responseModel = await JwtAxios.get(
      `/Template/Market/ShopifyOAuthCallback?${queryString}`
    );
    return responseModel;
  }
};
